'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UICardSection;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UICardSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      scrollable = _ref.scrollable,
      other = _objectWithoutProperties(_ref, ['className', 'children', 'flush', 'scrollable']);

  return _react2.default.createElement(
    'div',
    _extends({}, other, {
      className: (0, _classNames2.default)('private-card__section', 'has--vertical-spacing', className, {
        'private-card__section--flush': flush,
        'private-card__section--scrollable': scrollable
      })
    }),
    children
  );
}

UICardSection.defaultProps = {
  flush: false,
  scrollable: false
};

UICardSection.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  scrollable: _react.PropTypes.bool
};

UICardSection.displayName = 'UICardSection';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/card/UICardSection.js
// module id = 126
// module chunks = 171